/**
 * Groups on a made-up planet (the welcome planet, the Tile Lab's specimens): three or more touching
 * tiles of a group kind count as one, as the rules group them, without a state to ask.
 */
import { GROUP_KINDS, RULES, type Grid, type Kind } from '@bramvasterd/terrella-rules';

/** 1 for every tile in a group, 0 elsewhere. */
export function storyGroups(grid: Grid, kind: Uint8Array): Uint8Array {
  const out = new Uint8Array(grid.count);
  const done = new Uint8Array(grid.count);
  for (let i = 0; i < grid.count; i++) {
    const k = kind[i] ?? 0;
    if (done[i] || !GROUP_KINDS.has(k as Kind)) continue;
    const comp = [i];
    done[i] = 1;
    for (const c of comp) {
      for (const j of grid.neighbors[c] ?? []) {
        if (!done[j] && kind[j] === k) {
          done[j] = 1;
          comp.push(j);
        }
      }
    }
    if (comp.length >= RULES.groupMin) for (const j of comp) out[j] = 1;
  }
  return out;
}
